import { actionCreator, TError } from 'store'

import {
  TAddAdminRequestPayload,
  TResetAdminFormActionPayload,
  IAdmin
} from './adminManagement.types'
import * as actionTypes from './adminManagement.actionTypes'

export const addAdminRequest = (payload: TAddAdminRequestPayload) =>
  actionCreator(actionTypes.ADD_ADMIN_REQUEST, payload)
export const addAdminSuccess = () => actionCreator(actionTypes.ADD_ADMIN_SUCCESS)
export const addAdminError = (payload: TError) =>
  actionCreator(actionTypes.ADD_ADMIN_ERROR, payload)

export const resetAdminFormAction = (payload: TResetAdminFormActionPayload) =>
  actionCreator(actionTypes.RESET_ADMIN_FORM_ACTION, payload)

export const fetchAdminsRequest = () => ({
  type: actionTypes.FETCH_ADMINS_REQUEST
})

export const fetchAdminsSuccess = (admins: IAdmin[]) => ({
  type: actionTypes.FETCH_ADMINS_SUCCESS,
  payload: admins
})

export const fetchAdminsFailure = (error: string) => ({
  type: actionTypes.FETCH_ADMINS_FAILURE,
  payload: error
})

export const toggleAdminSuspendRequest = (adminId: string) => ({
  type: actionTypes.TOGGLE_ADMIN_SUSPEND_REQUEST,
  payload: adminId
})

export const toggleAdminSuspendSuccess = (admin: IAdmin) => ({
  type: actionTypes.TOGGLE_ADMIN_SUSPEND_SUCCESS,
  payload: admin
})

export const toggleAdminSuspendFailure = (error: string) => ({
  type: actionTypes.TOGGLE_ADMIN_SUSPEND_FAILURE,
  payload: error
})
